import React from 'react';
import { motion } from 'framer-motion';
interface PageProps {
  children: React.ReactNode;
  pageNumber?: number;
  hideFooter?: boolean;
  variant?: 'dark' | 'light' | 'burgundy';
}
export function Page({
  children,
  pageNumber,
  hideFooter = false,
  variant = 'dark'
}: PageProps) {
  const bgClass = variant === 'burgundy' ? 'bg-burgundy' : variant === 'light' ? 'bg-[#F5F5F0]' : 'bg-charcoal';
  const footerTextClass = variant === 'light' ? 'text-[#8A8A80]' : 'text-[#9CA3AF]';
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.5
  }} className={`w-[816px] h-[1056px] shadow-page relative flex flex-col shrink-0 overflow-hidden ${bgClass}`} data-id="element-150">
      {/* Content Area */}
      <div className="flex-1 p-12 pb-24 flex flex-col relative z-10" data-id="element-151">
        {children}
      </div>

      {/* Footer */}
      {!hideFooter && <div className="absolute bottom-0 left-0 w-full px-12 pb-12 flex justify-between items-end z-20" data-id="element-152">
          <div className={`font-sans text-xs font-bold tracking-widest uppercase ${footerTextClass}`} data-id="element-153">
            Structured Nutrition | The GLP-1 Nutrition Guide
          </div>
          {pageNumber && <div className="w-10 h-10 bg-tealslate text-white flex items-center justify-center font-sans font-bold text-lg" data-id="element-154">
              {pageNumber}
            </div>}
        </div>}
    </motion.div>;
}